/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import uniqWith from 'lodash/uniqWith';
import cacheAxios from '../../util/cacheAxios';

const hrPredictAxios = axios.create();
const cache = new Map();
cacheAxios(hrPredictAxios, cache);

hrPredictAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims#/hrpredict';
      }, 500);
    }
  });

function bonusComparator(a, b) {
  const aString = `${a.year}-${a.bonusType}-${a.gicsCode || ''}-${a.country}`;
  const bString = `${b.year}-${b.bonusType}-${b.gicsCode || ''}-${b.country}`;
  return aString === bString;
}
function attritionComparator(a, b) {
  const aString = `${a.year}-${a.countryCode}-${a.gicsCode || ''}`;
  const bString = `${b.year}-${b.countryCode}-${b.gicsCode || ''}`;
  return aString === bString;
}

export default {
  state: {
    // metricToPredict: '',
    // sectorToPredict: 0,
    // countriesToPredict: [],
    // yearsToPredict: [],
    // factorsUsed: [],
    // forecasts: [],
    // publicIncrementData: [],
    // publicBonusData: [],
    // publicAttritionData: [],
    // previousIncrementData: [],
    // previousBonusData: [],
    // previousAttritionData: [],
    // loading: false,
  },
  mutations: {
    // setHrPredictLoading(state, value) {
    //   state.loading = value;
    // },
    // setMetricToPredict(state, metric) {
    //   state.metricToPredict = metric;
    // },
    // setSectorToPredict(state, sector) {
    //   state.sectorToPredict = sector;
    // },
    // setCountriesToPredict(state, countries) {
    //   state.countriesToPredict = countries;
    // },
    // setYearsToPredict(state, years) {
    //   state.yearsToPredict = years;
    // },
    // setFactorsUsed(state, factors) {
    //   state.factorsUsed = factors;
    // },
    // setForecasts(state, forecasts) {
    //   forecasts.map((f) => {
    //     if (f.evidentLvl.costPressure == null && f.evidentLvl.revMomentum == null
    //       && f.evidentLvl.cpic != null && f.evidentLvl.gagr != null) {
    //       const fake = f;
    //       fake.evidentLvl.fake = true;
    //       const avg = Math.round((f.evidentLvl.cpic + f.evidentLvl.gagr) / 2);
    //       fake.evidentLvl.costPressure = avg;
    //       fake.evidentLvl.revMomentum = avg;
    //       return fake;
    //     }
    //     return f;
    //   });
    //   state.forecasts = forecasts;
    // },
    // setPublicIncrementData(state, data) {
    //   state.publicIncrementData = data;
    // },
    // addPublicBonusData(state, data) {
    //   state.publicBonusData.push(...data);
    //   state.publicBonusData = uniqWith(state.publicBonusData, bonusComparator);
    // },
    // addPublicAttritionData(state, data) {
    //   state.publicAttritionData.push(...data);
    //   state.publicAttritionData = uniqWith(state.publicAttritionData, attritionComparator);
    // },
    // setPreviousIncrementData(state, data) {
    //   state.previousIncrementData = data;
    // },
    // addPreviousBonusData(state, data) {
    //   state.previousBonusData.push(...data);
    //   state.previousBonusData = uniqWith(state.previousBonusData, bonusComparator);
    // },
    // clearPreviousBonus(state) {
    //   state.previousBonusData = [];
    // },
    // addPreviousAttritionData(state, data) {
    //   state.previousAttritionData.push(...data);
    //   state.previousAttritionData = uniqWith(state.previousAttritionData, attritionComparator);
    // },
  },
  actions: {
    saveIncrementLocationList(_, list) {
      return hrPredictAxios.post('/aims/api/increment/saveIncrementLocationList', list);
    },

    retrieveIncrementLocationList() {
      return hrPredictAxios.get('/aims/api/increment/userIncrementLocationList');
    },

    removeIncrementLocationList(_, listName) {
      return hrPredictAxios.delete(`/aims/api/increment/userIncrementLocationList/${listName}`);
    },

    getBonusData({
      state,
      commit,
    }, { year, bonusType, countries }) {
      return hrPredictAxios.post(`/aims/api/increment/publicBonus/${year}/${encodeURIComponent(bonusType.replace('/', '|'))}`,
       countries)
        .then((res) => {
          if (res.data !== null) {
            return res.data;
          }
          return [];
        });
    },
    getAttritionData({
      state,
      commit,
    }, { year, countries }) {
      return hrPredictAxios.post(`/aims/api/increment/publicAttrition/${year}`,
        countries)
        .then((res) => {
          if (res.data !== null) {
            return res.data;
          }
          return [];
        });
    },
    getSalaryData({
      state,
      commit,
    }, year) {
      return hrPredictAxios.get(`/aims/api/increment/public/${year}`)
        .then((res) => {
          if (res.data !== null) {
            return res.data;
          }
          return [];
        });
    },
    getIncrementFactor({
      state,
      commit,
    }, {
      metric,
      sector,
      countryCodes,
      years,
      factors,
    }) {
      const req = {
        sector,
        countryCodes,
        years,
        factors,
      };
      return hrPredictAxios.post(`/aims/api/increment/forecast/${metric}`, req, {
          cache: true,
          cacheKey: req,
        });
    },
  },
  getters: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/hrPredictModule.js